import type { IconButtonProps as MuiIconButtonProps } from '@mui/material';
import { IconButton as MuiIconButton } from '@mui/material';
import { Cancel32 } from '@packages/themes/icons';

export type CloseIconButtonProps = Omit<MuiIconButtonProps, 'icon'>;

/** Transparent icon button with cancel icon. Based on MUI IconButton https://mui.com/material-ui/api/icon-button/ */
export const CloseIconButton = (props: CloseIconButtonProps) => (
  <MuiIconButton data-testid="close-iconbutton" size="small" aria-label="Close" {...props}>
    <Cancel32 />
  </MuiIconButton>
);
